import React from 'react';
import { SubMenuLink } from "../../SubMenuLink";

const createNotification = () => {
    return <SubMenuLink pathname="/notification" title="Create notification" icon="CREATE_LIGHT" />
};

export default createNotification;